import styled from 'styled-components';

import {colors, font} from '@/app/styles/theme';
import {UserStatus} from '@/entities/eployersControl/type';

export const StatusLabelStyled = styled.div<{$status: UserStatus}>`
    padding: 7px 10px;
    margin: 3px;
    border-radius: 4px;
    background: ${({$status}) => {
        switch ($status) {
            case 'ACTIVE':
                return `${colors.successSecondary}`;
            case 'INVITED':
                return '#FFEFD9';
            default:
                return `${colors.dangerSecondary}`;
        }
    }};
    color: ${({$status}) => {
        switch ($status) {
            case 'ACTIVE':
                return colors.success;
            case 'INVITED':
                return '#FF9500';
            default:
                return `${colors.danger}`;
        }
    }};

    font-family: ${font.family.primary};
    font-size: 14px;
    font-weight: 500;
    line-height: 12px;
`;
